import React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import Button from '../AppButton/Button';
import FormInputText from './Inputs/FormInputText';
import { ParentPasswordChangeFormType } from './form-types';
import { transformErrors } from '../../services/utils';
import { GlobalTypes, useGlobalState } from '../../contexts/global';
import { changeParentPassword } from '../../moduls/profile';

const initialValues = {
    parent_password: '',
    new_parent_password: '',
    new_parent_password_confirmation: ''
};

const attributes = {
    parent_password: {
        placeholder: 'Vyplňte..',
        label: 'Staré rodičovské heslo',
        password: true
    },
    new_parent_password: {
        placeholder: 'Vyplňte..',
        label: 'Nové rodičovské heslo',
        password: true
    },
    new_parent_password_confirmation: {
        placeholder: 'Vyplňte..',
        label: 'Nové rodičovské heslo znovu',
        password: true
    }
};

const ChangeParentPasswordForm: React.FC<{}> = () => {
    const { dispatch } = useGlobalState();
    const onSubmit = async (values: ParentPasswordChangeFormType, { setErrors, resetForm }: FormikHelpers<ParentPasswordChangeFormType>) => {
        return changeParentPassword(values)
            .then(() => {
                resetForm();
                dispatch({ type: GlobalTypes.ToggleModal, modal: '' });
                dispatch({ type: GlobalTypes.ToggleNotification, style: 'success', text: 'Rodičovské heslo bylo úspěšně změněno.'})
            })
            .catch((error) => setErrors(transformErrors(error)));
    };

    const validationSchema = Yup.object().shape({
        // eslint-disable-next-line
        parent_password: Yup.string().min(8, 'Minimální délka je ${min} znaků').required('Povinné pole'),
        // eslint-disable-next-line
        new_parent_password: Yup.string().min(8, 'Minimální délka je ${min} znaků').required('Povinné pole'),
        new_parent_password_confirmation: Yup.string()
            .oneOf([Yup.ref('new_parent_password'), undefined], 'Hesla se musí shodovat')
            .required('Povinné pole'),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
            {({ isValid, dirty, isSubmitting }) => (
                <Form>
                    <FormInputText name="parent_password" attributes={attributes.parent_password} />
                    <FormInputText name="new_parent_password" attributes={attributes.new_parent_password} />
                    <FormInputText name="new_parent_password_confirmation" attributes={attributes.new_parent_password_confirmation} />
                    <div className="h-text-center h-mt-1">
                        <Button type="submit" color="primary" disabled={!(isValid && dirty)} loading={isSubmitting}>
                            Odeslat
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default ChangeParentPasswordForm;
